import React, { CSSProperties } from "react";
import ct from "class-types.macro";
import type { Placement } from "tippy.js";

function PopupArrow({ placement }: { placement: Placement }) {
  const commonClasses: { [placement: string]: string } = {
    top: ct(
      "border-transparent",
      "border-solid",
      "border-b-0",
      "block",
      "h-0",
      "absolute",
      "w-0",
    ),
    bottom: ct(
      "border-transparent",
      "border-solid",
      "border-t-0",
      "block",
      "h-0",
      "absolute",
      "w-0",
    ),
    right: ct(
      "border-transparent",
      "border-solid",
      "border-l-0",
      "block",
      "h-0",
      "absolute",
      "w-0",
    ),
    left: ct(
      "border-transparent",
      "border-solid",
      "border-r-0",
      "block",
      "h-0",
      "absolute",
      "w-0",
    ),
  };

  const arrowClasses: { [placement: string]: string } = {
    top: ct("border-11", "-bottom-2-3/4", "z-10"),
    bottom: ct("border-11", "-top-2-3/4", "z-10"),
    right: ct("border-11", "-left-2-3/4", "z-10"),
    left: ct("border-11", "-right-10px", "z-10"),
  };

  const arrowStyle: { [placement: string]: CSSProperties } = {
    right: { borderRightColor: "rgba(0, 0, 0, 0.25)" },
    top: { borderTopColor: "rgba(0, 0, 0, 0.25)" },
    bottom: { borderBottomColor: "rgba(0, 0, 0, 0.25)" },
    left: { borderLeftColor: "rgba(0, 0, 0, 0.25)" },
  };

  const afterClasses: { [placement: string]: string } = {
    top: ct(
      "border-10",
      "bottom-2-1/4",
      "transform",
      "-translate-x-1/2",
      "translate-y-1/2",
    ),
    bottom: ct(
      "border-10",
      "top-2-1/4",
      "transform",
      "-translate-x-1/2",
      "-translate-y-1/2",
    ),
    right: ct(
      "border-10",
      "left-2-1/4",
      "transform",
      "-translate-x-1/2",
      "-translate-y-1/2",
    ),
    left: ct(
      "border-10",
      "right-2-1/4",
      "transform",
      "translate-x-1/2",
      "-translate-y-1/2",
    ),
  };

  const afterStyle: { [placement: string]: CSSProperties } = {
    right: { borderRightColor: "#fff" },
    bottom: { borderBottomColor: "#fff" },
    top: { borderTopColor: "#fff" },
    left: { borderLeftColor: "#fff" },
  };

  return (
    <div
      id="arrow"
      className={`${commonClasses[placement]} ${arrowClasses[placement]}`}
      style={arrowStyle[placement]}
      data-popper-arrow
    >
      <div
        className={`${commonClasses[placement]} ${afterClasses[placement]}`}
        style={afterStyle[placement]}
      />
    </div>
  );
}
export default PopupArrow;
